/**
 * PageSummary — compact 3-KPI strip rendered at the top of each tab.
 *
 * Replaces the shared 5-card "Commercial Impact" strip. Each page
 * passes the 3 KPIs most relevant to its purpose so there is no
 * duplication across tabs.
 */
import React from 'react';

export default function PageSummary({ metrics = [] }) {
    if (!metrics.length) return null;
    return (
        <div
            data-testid="page-summary"
            className="grid grid-cols-1 sm:grid-cols-3 gap-3 rounded-lg border border-slate-200 bg-white p-4"
        >
            {metrics.map((m, idx) => (
                <div
                    key={m.label}
                    data-testid={m.testid}
                    className={idx > 0 ? 'sm:border-l sm:border-slate-200 sm:pl-4' : ''}
                >
                    <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">
                        {m.label}
                    </div>
                    <div className={`text-xl font-bold mt-0.5 tabular-nums ${m.accent || 'text-slate-900'}`}>
                        {m.value}
                    </div>
                    {m.hint && (
                        <div className="text-xs text-slate-500 mt-0.5">{m.hint}</div>
                    )}
                </div>
            ))}
        </div>
    );
}
